// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"16ffef2e","465":"f5edce29","513":"884d8d1c","543":"c7a9d220","787":"43a7433c"}[chunkId] + ".chunk.js";
};